export default "__VITE_ASSET__Dn7A7n48__"